import React from 'react';
import { FadeIn } from './FadeIn';
import { HeartPulse } from 'lucide-react';
export function ProofSection() {
  return <section className="w-full bg-white py-20 md:py-28 px-6" data-id="element-166">
      <div className="max-w-4xl mx-auto" data-id="element-167">
        <FadeIn data-id="element-168">
          <div className="bg-cream-dark rounded-3xl p-8 md:p-16 text-center relative overflow-hidden shadow-sm border border-amber/10" data-id="element-169">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-gradient-to-r from-transparent via-amber to-transparent opacity-50" data-id="element-170"></div>

            <HeartPulse className="w-16 h-16 text-amber mx-auto mb-8" data-id="element-171" />

            <h2 className="text-3xl md:text-4xl font-serif text-slate-900 mb-8" data-id="element-172">
              Lo que cambia en 5 minutos:
            </h2>

            <p className="text-xl md:text-2xl text-slate-700 leading-relaxed mb-10 font-medium" data-id="element-173">
              Al aplicar el Protocolo 5-5-5, el ritmo cardíaco baja de forma
              medible y la sensación de "nudo en la garganta" desaparece.
            </p>

            <div className="inline-block bg-white px-8 py-4 rounded-xl shadow-sm border border-slate-100" data-id="element-174">
              <p className="text-lg text-slate-800 italic font-serif" data-id="element-175">
                "No es magia, es cómo funciona el sistema nervioso humano cuando
                recibe los estímulos correctos."
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}